import { defineComponent as D, useSlots as b, watch as O, openBlock as d, createBlock as f, unref as t, withCtx as i, createVNode as l, createElementVNode as s, normalizeClass as M, createTextVNode as u, toDisplayString as p, createCommentVNode as m, renderSlot as x, createElementBlock as C } from "vue";
import { DialogRoot as B, DialogPortal as E, DialogOverlay as j, DialogContent as z, DialogTitle as N, DialogDescription as S, DialogClose as V } from "radix-vue";
import { c as T } from "./cn-Bje3WtSp.js";
const U = { class: "mb-4 flex shrink-0 items-start justify-between gap-4" }, W = { class: "min-h-0 flex-1 overflow-y-auto text-sm text-text-primary" }, $ = {
  key: 0,
  class: "mt-6 flex shrink-0 justify-end gap-2"
}, R = /* @__PURE__ */ D({
  __name: "Modal",
  props: {
    open: { type: Boolean },
    title: {},
    description: { default: void 0 },
    dirty: { type: Boolean, default: !1 },
    maxWidth: { default: "md" },
    class: { default: void 0 }
  },
  emits: ["update:open", "dirty-close-intent"],
  setup(n, { emit: g }) {
    const r = n, c = g, k = b(), o = globalThis;
    o.__koriModalOpen = o.__koriModalOpen ?? 0, O(
      () => r.open,
      (e, a) => {
        e && !a ? (o.__koriModalOpen = (o.__koriModalOpen ?? 0) + 1, (o.__koriModalOpen ?? 0) > 1 && console.warn(
          `[@kori/ui] Modal stacking is not permitted (UI Spec §8.6). Found ${o.__koriModalOpen ?? 0} open modals. Use a Drawer or Wizard pattern instead.`
        )) : !e && a && (o.__koriModalOpen = Math.max(0, (o.__koriModalOpen ?? 1) - 1));
      },
      { immediate: !0 }
    );
    function v(e) {
      if (!e && r.dirty) {
        c("dirty-close-intent");
        return;
      }
      c("update:open", e);
    }
    function _(e) {
      e.detail?.originalEvent?.target?.closest("[data-kori-popover]") && e.preventDefault();
    }
    function h(e) {
      e.detail?.originalEvent?.target?.closest("[data-kori-popover]") && e.preventDefault();
    }
    function y(e) {
      e.detail?.originalEvent?.target?.closest("[data-kori-popover]") && e.preventDefault();
    }
    const w = {
      sm: "max-w-md",
      md: "max-w-[560px]",
      lg: "max-w-[760px]",
      xl: "max-w-[960px]",
      "2xl": "max-w-[1152px]"
    };
    return (e, a) => (d(), f(t(B), {
      open: n.open,
      "onUpdate:open": v
    }, {
      default: i(() => [
        l(t(E), null, {
          default: i(() => [
            l(t(j), { class: "fixed inset-0 z-40 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out" }),
            l(t(z), {
              class: "fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-4 focus:outline-none pointer-events-none",
              onPointerDownOutside: _,
              onInteractOutside: h,
              onFocusOutside: y
            }, {
              default: i(() => [
                s("div", {
                  class: M(t(T)(
                    "pointer-events-auto flex max-h-[90vh] w-full flex-col rounded-3xl bg-surface-default p-6 shadow-4",
                    w[n.maxWidth],
                    r.class
                  ))
                }, [
                  s("header", U, [
                    s("div", null, [
                      l(t(N), { class: "text-lg font-semibold text-text-primary" }, {
                        default: i(() => [
                          u(p(n.title), 1)
                        ]),
                        _: 1
                      }),
                      n.description ? (d(), f(t(S), {
                        key: 0,
                        class: "mt-1 text-sm text-text-secondary"
                      }, {
                        default: i(() => [
                          u(p(n.description), 1)
                        ]),
                        _: 1
                      })) : m("", !0)
                    ]),
                    l(t(V), {
                      "aria-label": "Close",
                      class: "inline-flex h-8 w-8 items-center justify-center rounded hover:bg-surface-sunken focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
                    }, {
                      default: i(() => [...a[0] || (a[0] = [
                        s("span", { "aria-hidden": "true" }, "×", -1)
                      ])]),
                      _: 1
                    })
                  ]),
                  s("div", W, [
                    x(e.$slots, "default")
                  ]),
                  t(k).footer ? (d(), C("footer", $, [
                    x(e.$slots, "footer")
                  ])) : m("", !0)
                ], 2)
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
});
export {
  R as _
};
//# sourceMappingURL=Modal.vue_vue_type_script_setup_true_lang-8e6IVXOo.js.map
